<template>
  <div class="availability-marker" :class="classes" :style="styles">
    <div class="availability-marker__ring" :style="{ animationDelay: animationDelay + 'ms' }"></div>
    <div class="availability-marker__dot"></div>
    <!-- <div class="availability-marker__count">{{ propertyCount }}</div> -->
  </div>
</template>
<script>
export default {
  props: ['animation-delay', 'available', 'filtered', 'property-count', 'x', 'y', 'status'],
  computed: {
    classes () {
      let classes = {}
      // Adjust the status conditions based on what you're expecting from the CRM - or better still: adjust the properties get request on the API to standardise to something like below
      classes['availability-marker--available'] = this.status === 'Available'
      classes['availability-marker--hold'] = this.status === 'On Hold' || this.status === 'Blocked'
      classes['availability-marker--management-blocked'] = this.status === 'Management Blocked'
      classes['availability-marker--sold'] = this.status === 'Sold'
      classes['availability-marker--filtered'] = this.filtered
      return classes
    },

    styles () {
      return {
        left: (this.x / 20) + 'rem',
        top: (this.y / 20) + 'rem'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
$marker-available-color: #6ed46b;
$marker-hold-color: #ee9440;
$marker-sold-color: #d31b1b;
$marker-management-blocked-color: #1678d4;

.availability-marker {
  padding: 2rem;
  position: absolute;
  transform: translate(-50%, -50%);
  display: none;

  &--hold {
    display: block;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-hold-color;
      opacity: 1;
    }

  }

  &--sold {
    // #d31b1b
    display: block;
    .availability-marker__dot {
      background-color: $marker-sold-color;
      opacity: 1;
    }
  }

  &--management-blocked {
    display: block;
    .availability-marker__dot {
      background-color: $marker-management-blocked-color;
      opacity: 1;
    }
  }

  &--available {
    display: block;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-available-color;
      
      opacity: 1;
      animation: dotpulse 2s ease-out;
      animation-iteration-count: infinite; 
    }

    .availability-marker__ring {
      border: 0.3rem solid $marker-available-color;
      border-radius: 3rem;
      height: 2rem;
      width: 2rem;
      position: absolute;
      animation: ripple 2s ease-out;
      animation-iteration-count: infinite; 
      opacity: 0.0;
    }
  }

  &--filtered {
    display: block;
    .availability-marker__dot {
      background-color: #858585;
      // opacity: 0;
      animation: none;
    }

    .availability-marker__ring {
      display: none;
    }
  }  

  &__dot {
    background: $dot-available;
    box-shadow: 0px 0px 5px #000, 0px 0px 10px #000, 0px 0px 15px #000;
    border-radius: 1rem;
    border: 0.2rem solid #fff;
    height: 2rem;
    transition: all 0.3s;
    width: 2rem;    
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);    
  }

  &__ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__count {
    background-color: rgba($white, 0.75);
    color: $black;
    font-size: 1.8rem;
    text-align: center;
    transition: all 0.3s;
    top: 100%;
    position: absolute;
    left: 50%;
    padding: 0 0.3em;
    transform: translateX(-50%);
    text-shadow:
    -1px -1px 0 $white,  
      1px -1px 0 $white,
      -1px 1px 0 $white,
      1px 1px 0 $white;
  }
}
</style>
